import { CmsApiRecommendedActionsBlockData } from 'modules/cms/api/types/CmsApiRecommendedActions';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpRecommendedActionsBlock } from './CmsAmpRecommendedActionsBlock';
import { CmsRecommendedActionsBlock } from './CmsRecommendedActionsBlock';

export const CmsRecommendedActionsBlockMapping: CmsBlockMapping<CmsApiRecommendedActionsBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsRecommendedActionsBlock,
    AmpComponent: CmsAmpRecommendedActionsBlock,
  };
